import { render, staticRenderFns } from "./OsmSolicitacoesPrazo.vue?vue&type=template&id=2f216827&scoped=true&lang=pug&"
import script from "./OsmSolicitacoesPrazo.vue?vue&type=script&lang=js&"
export * from "./OsmSolicitacoesPrazo.vue?vue&type=script&lang=js&"
import style0 from "./OsmSolicitacoesPrazo.vue?vue&type=style&index=0&id=2f216827&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f216827",
  null
  
)

export default component.exports